/******************************** Import Package ************************************/
import React, { useState, useEffect } from "react";
import { responseStatusHandler } from "../../Api/actions";
import { hostConfig } from "../../Config";
import Notification from "../../Components/Notification";
import Loader from "../../Components/Loader";
import { postRefreshTokensData } from "../../Api/create";

const GoogleAuth = () => {
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    let query = new URLSearchParams(window.location.search)
    if (query.has("access") && query.has('userId') && query.has('refresh')) {
      // let accessToken = query.get('access')
      let refreshToken = query.get('refresh')
      let userId = query.get('userId')

      // localStorage.setItem("accessToken", accessToken);
      // localStorage.setItem("refreshToken", refreshToken);

      postRefreshTokensData({ refreshToken: `${refreshToken}` }).then((res) => {
        if (responseHandler(res)) {
        // if (res) {
          let accessToken = res.access.token;
          let refreshToken = res.refresh.token;
          let accessExpiry = res.access.expires;
          let refreshExpiry = res.refresh.expires;
          localStorage.setItem("accessToken", accessToken);
          localStorage.setItem("refreshToken", refreshToken);
          localStorage.setItem("accessExpiry", accessExpiry);
          localStorage.setItem("refreshExpiry", refreshExpiry);
          fetch(`${hostConfig.API_URL}users/${userId}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: "Bearer " + accessToken,
            },
          })
            .then((response) => {
              return responseStatusHandler(response);
            })
            .then((result) => {
              return result.status === 200 || result.status === 201 || result.status === 400 ?
                result.json()
                : result
            }).then(res => {
              if (responseHandler(res)) {
                currentUserRole(res[0].role)
                localStorage.setItem("loggedUser", JSON.stringify(res[0]));
    
                if (JSON.parse(localStorage.getItem("loggedUser"))) {
                  setNotify({
                    isOpen: true,
                    message: "Logged in successfully",
                    type: "success",
                  });
                  window.location.href = "/dashboard";
                } else {
                  setNotify({
                    isOpen: true,
                    message: "Invalid details",
                    type: "error",
                  });
                }
              }
            })
            .catch((error) => {
              return false;
            });
        } else {
          return false
        }
      
      });

     
    };

  }, []);

  const responseHandler = (res) => {
    if (res) {
      if (res.code) {
        if (res.code === 400) {
          setNotify({
            isOpen: true,
            message: res.message,
            type: "error",
          });
          return false;
        } else {
          setNotify({
            isOpen: true,
            message: "Bad Request",
            type: "error",
          });
          return false;
        }
      } else if (res.error) {
        setNotify({
          isOpen: true,
          message: res.error,
          type: "error",
        });
        return false;
      } else {
        return res;
      }
    } else {
 // setNotify({
      //   isOpen: true,
      //   message: "Check Your internet connection",
      //   type: "error",
      // });
      return false;
    }
  };


  
  const currentUserRole = (userRole) => {
    if (userRole.includes("admin")) {
      localStorage.setItem("currentUser", "admin");
    } else if (userRole.includes("approver")) {
      localStorage.setItem("currentUser", "approver");
    } else if (userRole.includes("sponsor")) {
      localStorage.setItem("currentUser", "sponsor");
    } else {
      localStorage.setItem("currentUser", "resource");
    }
  }
  
  if (JSON.parse(localStorage.getItem("loggedUser"))) {
    window.location.href = "/dashboard";
  }

  return (<>
    <Loader loading={true} />
    <Notification notify={notify} setNotify={setNotify} />
  </>);
};

export default GoogleAuth;
